import { useLightMe } from "@myaccount/_client/hooks";

export const usePrimaryTravelerForBooking = (bookingId: string) => {
    const { customer } = useLightMe();
    if (!customer) {
        return null;
    }

    const { confirmedTrips, requestedTrips, pendingRebookingTrips } = customer;

    const booking = (
        confirmedTrips.find((trip) => trip.booking?._id === bookingId) ??
        requestedTrips.find((trip) => trip.booking?._id === bookingId) ??
        pendingRebookingTrips.find((trip) => trip.booking?._id === bookingId)
    )?.booking;

    const primaryTrip = booking?.trips.find((trip) => trip.isPrimary);

    return {
        isLoggedInAsPrimaryTraveler:
            primaryTrip?.customer?._id === customer._id,
        primaryTraveler: primaryTrip?.customer,
    };
};
